/**
 * Utilidad para restricción de teclas en inputs.
 * Usado por directivas de número de documento por tipo, etc.
 */

const CONTROL_KEYS = [
  'Backspace',
  'Tab',
  'ArrowLeft',
  'ArrowRight',
  'Delete',
  'Home',
  'End',
] as const;

/** Permite teclas de control (Ctrl, Cmd, navegación, borrado). */
export function allowControlKeys(event: KeyboardEvent): boolean {
  if (event.ctrlKey || event.metaKey) return true;
  return CONTROL_KEYS.includes(event.key as (typeof CONTROL_KEYS)[number]);
}

/** Permite solo dígitos. */
export function isDigitKey(key: string): boolean {
  return /^\d$/.test(key);
}

/** Permite solo mayúsculas A-Z, dígitos 0-9 y guión. Para CE/PA. */
export function isUppercaseAlphanumericKey(key: string): boolean {
  return /^[A-Z0-9-]$/.test(key);
}

/** Permite solo minúsculas a-z (para convertir a mayúsculas en CE/PA). */
export function isLowercaseLetterKey(key: string): boolean {
  return /^[a-z]$/.test(key);
}
